// Who a reply on one email thread copies, its subject and threading headers. Fetched
// only once the operator edits the email or makes its draft, never on mount: a run
// renders a card per email and none needs it until someone acts.
import { useQuery } from "react-query";

import type { ReplyContext } from "../gmailDrafts";
import { queryKeys } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";

export const useReplyContext = (threadUploadId: string, wanted: boolean) => {
  const http = useAgentsHttp();
  return useQuery<ReplyContext>(
    queryKeys.replyContext(threadUploadId),
    () => http<ReplyContext>("/uploads/reply_context", { upload_id: threadUploadId }),
    {
      enabled: wanted && !!threadUploadId,
      refetchOnWindowFocus: false,
      // Fetched only when the operator acts, and awaited: a refused fetch must fail at
      // once with its message rather than hold like a page's queries.
      retry: false,
      // A new message on the thread changes who to copy, but not within a sitting.
      staleTime: 5 * 60 * 1000,
    },
  );
};
